(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
  // The Google merchant widget inserts its iframe without an accessible title.
  function labelHoffeeMerchantWidget() {
    const frame = document.getElementById('merchantwidgetiframe');
    if (!frame) return false;
    if (!frame.getAttribute('title')) frame.setAttribute('title', 'Google store information for HOFFEE');
    return true;
  }
  if (!labelHoffeeMerchantWidget()) {
    const merchantWidgetObserver = new MutationObserver(() => {
      if (labelHoffeeMerchantWidget()) merchantWidgetObserver.disconnect();
    });
    merchantWidgetObserver.observe(document.documentElement, { childList: true, subtree: true });
    window.addEventListener('pagehide', () => merchantWidgetObserver.disconnect(), { once: true });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
